
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    icon: { type: String, default: 'icon-no-data' },
  },
  setup() {
    return {};
  },
});
